import UserIcon, { UserIconProps } from './UserIcon';

export type { UserIconProps };
export default UserIcon;
